import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import React, { PropsWithChildren, ReactElement, ReactNode } from 'react';
import {
  Control,
  Controller,
  FieldValues,
  Path,
  RegisterOptions,
  UseFormReturn,
} from 'react-hook-form';

export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DATETIME_DISPLAY_FORMAT = 'MM/DD/YYYY hh:mm A';

export interface FormDateTimePickerProps<T extends object> {
  form: UseFormReturn<T>;
  label: ReactNode;
  fieldName: Path<T>;
  format?: string;
  placeholder?: string;
  validation?: RegisterOptions;
}
export const FormDateTimePicker = <T extends FieldValues>(
  props: PropsWithChildren<FormDateTimePickerProps<T>>,
): ReactElement | null => {
  const { form, label, fieldName, validation, format } = props;
  return (
    <Controller
      control={form.control as Control<FieldValues>}
      name={fieldName}
      rules={validation}
      render={({ field: { onChange, onBlur, value, name } }) => {
        return (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DateTimePicker']}>
              <DateTimePicker
                label={label}
                name={name}
                onChange={(newValue) => {
                  const formattedValue = newValue ? dayjs(newValue).format(DATETIME_FORMAT) : '';
                  onChange(formattedValue);
                }}
                onAccept={(newValue) => {
                  const formattedValue = newValue ? dayjs(newValue).format(DATETIME_FORMAT) : '';
                  onChange(formattedValue);
                  onBlur();
                }}
                value={value ? dayjs(value) : null}
                defaultValue={value ? dayjs(value) : null}
                ampm
                format={format || DATETIME_DISPLAY_FORMAT}
                closeOnSelect={false}
                onClose={onBlur}
                sx={{width: '100%', marginTop: "8px !important"}}
              />
            </DemoContainer>
          </LocalizationProvider>
        );
      }}
    />
  );
}; 
